<template>
  <div class="account">
    <div id="modify_login_pwd">
      <el-form
        :model="infoForm"
        ref="infoForm"
        label-width="104px"
        class="demo-ruleForm account-info-form"
        size="mini"
      >
        <el-form-item label="真实姓名：" prop="actual_name">
          <div class="personal_info">
            {{ infoForm.actual_name }}
          </div>
        </el-form-item>
        <el-form-item label="证件号码：" prop="ID_num">
          <div class="personal_info">
            {{ infoForm.ID_num }}
          </div>
        </el-form-item>
        <el-form-item label="手机号：" prop="ph_num">
          <div class="personal_info">
            {{ infoForm.ph_num }}
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="account-content">
      <div class="section-title">认证收款账户</div>
      <div class="account-list">
        <div
          class="account-item"
          v-for="(item, index) in accountList"
          :key="index"
        >
          <div class="account-item-head">
            <div class="account-item-head-left">
              <img :src="item.logo" alt="" class="account-item-head-left__logo"/>
              <div class="account-item-head-left__name">
                {{ item.account_type }}账户
              </div>
            </div>
            <div :class="[item.account ? 'el-icon-check' : '', 'inputed']">
              {{ item.account ? "已认证" : "未录入" }}
            </div>
          </div>
          <div :class="['account-item-content', !item.account ? 'is-empty' : '']">
            <img
              v-if="!item.account"
              src="@/assets/image/PersonalCenter/MyAccount/Frame.png"
              alt=""
            />
            <template v-else>
              <div class="account-item-content__detail" v-if="item.type === 3">
                <div>账户类型</div>
                <div v-if="!item.is_public">个人账户</div>
                <div v-else>公司账户</div>
              </div>
              <!-- <div class="account-item-content__detail" v-if="item.type !== 3">
                <div>用户姓名</div>
                <div>{{ item.username }}</div>
              </div> -->
              <div class="account-item-content__detail">
                <div>{{ item.type !== 3 ? '用户姓名' : item.is_public ? "公司名称" : "用户姓名" }}</div>
                <div>{{ item.dese_name }}</div>
              </div>
              <div class="account-item-content__detail">
                <div>{{ item.account_type }}{{ item.type !== 3 ? '账户' : '账号' }}</div>
                <div>{{ item.dese_account }}</div>
              </div>
              <!-- <div class="account-item-content__detail" v-else>
                <div>{{ item.account_type }}账号</div>
                <div>{{ item.account }}</div>
              </div> -->
              <div
                class="account-item-content__detail"
                v-if="item.type === 3 && item.is_public === 1"
              >
                <div>开户行</div>
                <div>{{ item.bank_name }}</div>
              </div>
              <div
                class="account-item-content__detail"
                v-if="item.type === 2 && item.qrcode"
              >
                <div>收款码</div>
                <div class="account-item-content__detail-qrcode"
                     @click="qrcodeShowOpen(item)">
                  <div class="tag">已上传</div>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </template>
          </div>
          <div class="account-item-footer" @click="openDialog(item)">
            {{ item.account ? "更换认证" : "去录入" }}
          </div>
        </div>
      </div>
    </div>
    <account-dialog ref="account" @refresh="getAccount"></account-dialog>
    <!-- 投递建立 -->
    <el-dialog
      :visible.sync="qrcodeShow"
      custom-class="loanQrcode"
      :show-close="false"
      width="280px"
      top="30vh"
      center>
          <span>
            <div class="loanQrcode-img">
              <img :src="qrcodeImg" alt="">
            </div>
            <div class="loanQrcode-btn">
              <img class="loanQrcode-close" src="@/assets/image/AccountDeal/close.png" alt=""
                   @click="qrcodeShowClose">
            </div>
          </span>
    </el-dialog>

  </div>
</template>
<script>
import {apiuserInfo, accountList, bankList} from "@/request/API";
import AlipayLogo from "@/assets/image/PersonalCenter/MyAccount/ali.png";
import WeChatLogo from "@/assets/image/PersonalCenter/MyAccount/wechat.png";
import BankLogo from "@/assets/image/PersonalCenter/MyAccount/bank.png";
import accountDialog from "../../Seller/components/accountDialog.vue";
import desensitization from "@/util/strReplace"; // 数据脱敏
export default {
  name: "",
  props: {},
  components: {
    accountDialog,
  },
  data() {
    return {
      infoForm: {
        actual_name: "",
        ID_num: "",
        ph_num: this.$store.state.userData.telphone,
      },
      accountList: [
        {
          logo: AlipayLogo,
          account_type: "支付宝",
          username: "",
          account: "",
          bank_code: "",
          bank_cnaps_code: "",
          is_public: 0,
          type: 1,
          user_id: "",
          id: "",
          dese_name: "",
          dese_account: "",
        },
        {
          logo: WeChatLogo,
          account_type: "微信",
          username: "",
          account: "",
          bank_code: "",
          bank_cnaps_code: "",
          is_public: 0,
          type: 2,
          user_id: "",
          id: "",
          dese_name: "",
          dese_account: "",
        },
        {
          logo: BankLogo,
          account_type: "银行卡",
          username: "",
          account: "",
          bank_code: "",
          bank_cnaps_code: "",
          opening_bank: "",
          is_public: 0,
          type: 3,
          user_id: "",
          id: "",
          dese_name: "",
          dese_account: "",
        },
      ],
      bank_list: [],
      //微信-收款二维码弹窗
      qrcodeShow: false,
      qrcodeImg: '',
    };
  },
  computed: {},
  methods: {
    /**
     * 微信-收款二维码弹窗
     */
    qrcodeShowOpen(item) {
      this.qrcodeShow = true
      this.qrcodeImg = item.qrcode
    },
    /**
     * 微信-收款二维码弹窗 关闭
     */
    qrcodeShowClose() {
      this.qrcodeShow = false
      this.qrcodeImg = ''
    },
    openDialog(item) {
      this.$refs.account.open(item);
    },
    getBasicInfo(fn) {
      apiuserInfo({
        action: "setacc",
      })
        .then((res) => {
          this.infoForm.actual_name = res.data.cert_name;
          this.infoForm.ID_num = res.data.cert_id;
          this.infoForm.ph_num = res.data.telphone;
          if (fn) fn();
        })
        .catch((err) => {
          this.$alert(err.msg, "注意", {
            confirmButtonText: "前往实名认证",
            confirmButtonClass: "withdraw_btn",
            customClass: "withdraw_tips",
            center: true,
            callback: (action) => {
              this.$router.push({
                path: "/personalCenter/personalInfo/rNameAuthentication",
              });
            },
          });
        });
    },
    getAccount() {
      accountList()
        .then((res) => {
          res.data.length &&
          res.data.forEach((item) => {
            var type =
              item.type === 1 ? "ali" : item.type === 2 ? "wx" : "bank";
            this.accountList.forEach((el) => {
              if (item.type === el.type) {
                el.dese_name = desensitization("name", item.username);
                el.username = item.username;
                el.dese_account = desensitization(type, item.account);
                el.account = item.account;
                el.bank_code = item.bank_code;
                el.bank_cnaps_code = item.bank_cnaps_code;
                el.opening_bank = item.opening_bank;
                el.is_public = item.is_public;
                el.user_id = item.user_id;
                el.id = item.id;
                el.qrcode = item.qrcode;
                el.bank_name = item.bank_name;
              }
            });
          });
        })
        .catch((err) => {
          this.$message({
            message: err.msg,
            center: true,
            type: "error",
          });
        });
    },
    getBankList() {
      bankList()
        .then((res) => {
          this.bank_list = res.data;
        })
        .catch((err) => {
          this.$message({
            message: err.msg,
            center: true,
            type: "error",
          });
        });
    },
  },
  mounted() {
    this.getBasicInfo(() => {
      this.getAccount();
      this.getBankList();
    });
  },
};
</script>
<style lang="less">
.withdraw_tips {
  width: 386px;
  background: #ffffff;
  border-radius: 4px;
  padding: 0 0 32px;
  box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));

  .el-message-box__header {
    padding: 36px 32px 0;

    .el-message-box__headerbtn {
      top: 18px;
      right: 18px;
      width: 20px;
      height: 20px;
    }

    .el-message-box__close {
      color: var(--text-muted, #9AA0AC);
      font-size: 18px;
      transition: color .2s ease, transform .2s ease;
    }

    .el-message-box__headerbtn:hover .el-message-box__close {
      color: var(--text-main, #1A1D24);
      transform: rotate(90deg);
    }

    .el-message-box__title {
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-main, #111827);
      line-height: 28px;
    }
  }

  .el-message-box__content {
    padding: 24px 32px 0;

    .el-message-box__message {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
      line-height: 22px;
    }
  }

  .el-message-box__btns {
    display: flex;
    justify-content: center;
    padding: 30px 32px 0;

    .withdraw_btn,
    button {
      width: 200px;
      height: 40px;
      padding: 0;
      border: none;
      background: var(--primary, #FF5A1F);
      border-radius: 3px;
      box-shadow: none;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 40px;
      text-align: center;
      transition: background .2s ease;
    }

    .withdraw_btn:hover,
    .withdraw_btn:focus,
    button:hover,
    button:focus {
      background: var(--primary-hover, #E84A12);
      color: #FFFFFF;
    }

    .withdraw_btn:active,
    button:active {
      background: var(--primary-hover, #E84A12);
    }
  }
}

.loanQrcode {
  width: 280px;
  background: transparent !important;
  border-radius: 4px;
  position: relative;
  overflow: visible;

  .el-dialog__body {
    position: relative;
    padding: 0px !important;

    .loanQrcode-img {
      img {
        width: 280px;
        display: block;
        border-radius: 4px;
        box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
      }
    }

    .loanQrcode-btn{
      display: flex;
      justify-content: center;
      .loanQrcode-close {
        width: 30px;
        position: absolute;
        bottom: -40px;
        cursor: pointer;
        transition: opacity .2s ease, transform .2s ease;
      }

      .loanQrcode-close:hover {
        opacity: .88;
        transform: scale(1.04);
      }
    }
  }

  .el-dialog__header {
    padding: 0;
  }
}
</style>
<style lang='less' scoped>
.account {
  width: 100%;
  min-height: 520px;
  padding: 32px 44px 44px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--text-main, #111827);

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  #modify_login_pwd {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .account-info-form {
      display: table;
      width: auto;
      max-width: 100%;
      margin: 0 auto;
    }

    /deep/ .el-input {
      width: 360px;
      max-width: 100%;
    }

    /deep/ .el-input__inner {
      width: 100%;
      height: 40px;
      padding: 0 14px;
      background: var(--bg-tag, #F7F5F2);
      border-radius: 4px;
      border: 1px solid var(--border-soft, #E8E4DE);
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-main, #111827);
      transition: border-color .2s ease, box-shadow .2s ease, background .2s ease;
    }

    /deep/ .el-input__inner:hover {
      border-color: var(--border-strong, #D8D2CA);
      background: #FFFFFF;
    }

    /deep/ .el-input__inner:focus {
      border-color: var(--primary, #FF5A1F);
      background: #FFFFFF;
      box-shadow: none;
    }

    /deep/ .is-error .el-input__inner {
      border-color: var(--danger, #EF4444);
      box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.08);
    }

    /deep/ .el-form-item__label {
      padding: 0 16px 0 0;
      text-align: right;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
      line-height: 40px;
    }

    /deep/ .el-form-item {
      min-height: 40px;
      margin-bottom: 22px;
    }

    /deep/ .el-form-item__content {
      min-height: 40px;
      line-height: 40px;
    }

    .personal_info {
      display: flex;
      width: 360px;
      max-width: 100%;
      min-height: 40px;
      align-items: center;
      padding: 0 14px;
      border-radius: 4px;
      background: var(--bg-tag, #F7F5F2);
      border: 1px solid var(--border-soft, #E8E4DE);
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-main, #111827);
    }
  }

  .account-content {
    width: 100%;
    max-width: 936px;
    margin-top: 16px;
    display: flex;
    flex-direction: column;
    font-family: PingFangSC-Regular, PingFang SC;

    .section-title {
      position: relative;
      display: flex;
      align-items: center;
      height: 24px;
      margin: 6px 0 20px;
      padding-left: 12px;
      font-size: 16px;
      font-weight: 600;
      color: var(--text-main, #111827);
      line-height: 24px;
    }

    .section-title:before {
      content: "";
      position: absolute;
      left: 0;
      top: 5px;
      width: 4px;
      height: 14px;
      border-radius: 2px;
      background: var(--primary, #FF5A1F);
    }

    .account-list {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 300px));
      justify-content: center;
      gap: 18px;
    }

    .account-item {
      min-width: 0;
      height: 278px;
      display: flex;
      flex-direction: column;
      padding: 20px 20px 0;
      background: var(--bg-card, #FFFFFF);
      border-radius: 4px;
      border: 1px solid var(--border-soft, #E8E4DE);
      box-shadow: 0 4px 14px rgba(26, 29, 36, 0.04);
      overflow: hidden;
      transition: border-color .2s ease, box-shadow .2s ease, transform .2s ease;

      &:hover {
        border-color: rgba(26, 29, 36, 0.28);
        box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
        transform: translateY(-2px);
      }

      &:hover .account-item-footer {
        color: var(--primary, #FF7A1A);
      }

      &-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: 34px;

        &-left {
          display: flex;
          align-items: center;
          min-width: 0;

          &__logo {
            width: 32px;
            height: 32px;
            flex: 0 0 32px;
            border-radius: 50%;
            box-shadow: 0 6px 14px rgba(26, 29, 36, 0.08);
          }

          &__name {
            font-weight: 500;
            color: var(--text-main, #111827);
            height: 22px;
            line-height: 22px;
            margin-left: 10px;
            font-size: 15px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .inputed {
          display: inline-flex;
          align-items: center;
          height: 24px;
          padding: 0 10px;
          border-radius: 4px;
          background: var(--bg-tag, #F0EDE8);
          font-size: 12px;
          font-weight: 500;
          color: var(--text-muted, #9AA0AC);
          line-height: 24px;
          white-space: nowrap;
        }

        .el-icon-check {
          background: var(--success-soft, #ECFDF5);
          color: var(--success, #22C55E);
        }

        .el-icon-check:before {
          margin-right: 4px;
          font-size: 12px;
        }
      }

      &-content {
        min-height: 154px;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin-top: 18px;
        padding: 16px 0 6px;
        border-top: 1px solid var(--border-soft, #E8E4DE);

        img {
          width: 86px;
          height: 68px;
          object-fit: contain;
          opacity: .82;
        }

        &.is-empty {
          background: linear-gradient(180deg, rgba(240, 237, 232, 0) 0%, rgba(240, 237, 232, .72) 100%);
        }

        &__detail {
          width: 100%;
          min-height: 22px;
          line-height: 22px;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 12px;
          font-weight: 400;
          color: var(--text-secondary, #5A5F6B);
          margin-bottom: 12px;
          font-size: 13px;

          > div:first-child {
            flex: 0 0 auto;
            color: var(--text-muted, #9AA0AC);
            white-space: nowrap;
          }

          > div:last-child {
            min-width: 0;
            color: var(--text-main, #111827);
            text-align: right;
            word-break: break-all;
          }

          &-qrcode {
            display: flex;
            align-items: center;
            cursor: pointer;
            color: var(--text-main, #1A1D24);

            .tag {
              min-width: 52px;
              height: 22px;
              padding: 0 8px;
              background: var(--bg-tag, #F0EDE8);
              border-radius: 4px;
              font-size: 11px;
              font-family: PingFang SC-Regular, PingFang SC;
              font-weight: 400;
              color: var(--text-main, #1A1D24);
              line-height: 22px;
              margin: 0 6px 0 0;
              text-align: center;
            }

            i {
              color: var(--text-main, #1A1D24);
              font-size: 10px;
            }
          }
        }
      }

      &-footer {
        height: 56px;
        line-height: 56px;
        text-align: center;
        font-size: 15px;
        font-weight: 500;
        color: var(--text-main, #1A1D24);
        cursor: pointer;
        border-top: 1px solid var(--border-soft, #E8E4DE);
        transition: color .2s ease, background .2s ease;
      }

      &-footer:hover {
        background: var(--bg-tag, #F0EDE8);
      }
    }
  }
}
</style>
